import { combineReducers } from 'redux';
import authorListReducer from './authorList';
import blogPostsReducer from './blogs';
import { ConnectWalletReducer } from './connectWalletHandler';
import filterReducer from './filters';
import hotCollectionsReducer from './hotCollections';
import nftReducer from './nfts';

export const rootReducer = combineReducers({
  NFT: nftReducer,
  hotCollection: hotCollectionsReducer,
  authors: authorListReducer,
  filters: filterReducer,
  blogs: blogPostsReducer,
  connectHandler: ConnectWalletReducer
});

const reducers = (state, action) => rootReducer(state, action);

export default reducers;